/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('components');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var isMounted = function isMounted(component) {
	// exceptions for flow control :(
	try {
		_reactDom2['default'].findDOMNode(component);
		return true;
	} catch (e) {
		return false;
	}
};

var InstagramPhoto = (function (_Component) {
	_inherits(InstagramPhoto, _Component);

	function InstagramPhoto() {
		_classCallCheck(this, InstagramPhoto);

		_Component.apply(this, arguments);

		this.state = {
			image: '',
			link: ''
		};
	}

	InstagramPhoto.prototype.componentDidMount = function componentDidMount() {
		var _this = this;

		_jquery2['default'].get(_srcSettings2['default'].cdn + 'instagram/').done(function (response) {
			var link = response.data[0].link;
			var image = response.data[0].images.standard_resolution.url;
			window.requestAnimationFrame(function () {
				if (isMounted(_this)) {
					_this.setState({
						image: image,
						link: link
					});
				}
			});
		}).fail(function () {
			console.log('Failed. :(');
		});
	};

	InstagramPhoto.prototype.render = function render() {
		var _classNames;

		var styles = require('./InstagramPhoto.css');

		var baseClassNames = _classnames2['default']((_classNames = {}, _classNames[styles.Base] = true, _classNames[this.props.className] = this.props.className, _classNames));

		if (!this.state.link) return false;
		return _react2['default'].createElement(
			'section',
			{ className: baseClassNames },
			_react2['default'].createElement(_components.HeaderTab, { icon: 'camera', title: 'Instagram', url: 'https://www.instagram.com/baltimore_brew/' }),
			_react2['default'].createElement(
				'div',
				{ className: styles.Article },
				_react2['default'].createElement(
					'a',
					{ href: this.state.link, target: '_blank' },
					_react2['default'].createElement('img', { className: styles.Photo, src: this.state.image })
				)
			)
		);
	};

	_createClass(InstagramPhoto, null, [{
		key: 'propTypes',
		value: {
			className: _react.PropTypes.string
		},
		enumerable: true
	}]);

	return InstagramPhoto;
})(_react.Component);

exports['default'] = InstagramPhoto;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/InstagramPhoto/InstagramPhoto.js
 ** module id = 681
 ** module chunks = 0
 **/